{
  "meta": {
    "title": "No SSN? No problem! - MAJORITY",
    "description": "Open an account without a Social Security number by visiting an advisor at any of our physical locations."
  },
  "no_ssn_hero": {
    "title": "No SSN? No problem",
    "body": "Open an account and get a free Visa® Debit Card without a Social Security number by visiting an advisor at any of our physical locations."
  },
  "no_ssn_content_box": {
    "tagline": "No SSN? No problem",
    "title": "Mobile banking without SSN",
    "body": "Regardless of immigration status, everyone deserves access to basic financial services. That’s why we’ve made it possible to open a MAJORITY account and get a Visa Debit Card even without an SSN. Just speak to an advisor so we can verify your identity with a government-issued ID, such as a passport or matrícula consular."
  },
  "us_citizen_content_box": {
    "tagline": "No SSN? No problem",
    "title": "Do I need to be a US citizen to open an account?",
    "body": "No. We welcome citizens and non-citizens alike. If you don’t have a Social Security number, just visit an advisor with a government-issued ID (US or foreign) to unlock the full money-saving benefits of MAJORITY.\nValid government-issued IDs:\n* Valid passport\n* Driver's license\n* State ID\n* Immigration ID or residence permit\n* Mexican matrícula consular\n* Other government-issued ID with photo"
  },
  "advisor_content_box": {
    "tagline": "No SSN? No problem",
    "title": "Visit an advisor near you",
    "body": "We have advisors ready to help you in your preferred language at hundreds of sales locations across Texas and Florida. Most of our advisors are migrants themselves, so they understand how difficult it is to open an account in a new country. Whether you have questions about mobile banking, debit cards, sending money, or making international calls, our dedicated customer support is here for you.",
    "cta": "See locations"
  },
  "user_reviews_title": "The reviews are in",
  "faq_title": "Frequently asked questions"
}
